/*
 * mp-behavior.js — minnepote 行为/点击流埋点
 * 经 window.mpTrack(已在 theme.liquid，受 cookie 同意门控)发到 GA4:
 *  mp_page(页面路径) / mp_scroll_depth(滚动) / mp_page_exit(退出) / mp_ad_click(广告)。
 * 零侵入、节流,不改任何现有功能。详见 docs/instrumentation/behavioral-tracking-plan.md
 */
(function () {
  'use strict';
  function track(name, props) { if (window.mpTrack) window.mpTrack(name, props); }

  function pageType(p) {
    if (p === '/' || p === '') return 'home';
    if (p.indexOf('/products/') === 0) return 'product';
    if (p.indexOf('/blogs/') === 0) return 'blog';
    if (p.indexOf('/collections/') === 0) return 'collection';
    if (p.indexOf('/pages/') === 0) return 'page';
    if (p.indexOf('/cart') === 0) return 'cart';
    return 'other';
  }

  var path = location.pathname.replace(/\/$/, '') || '/';
  var ptype = pageType(path);

  function referrerPath() {
    try {
      if (!document.referrer) return '(direct)';
      var u = new URL(document.referrer);
      if (u.host !== location.host) return '(external)';
      return u.pathname.replace(/\/$/, '') || '/';
    } catch (e) { return '(direct)'; }
  }

  function navIndex() {
    var k = 'mp_nav_index';
    var n = parseInt(sessionStorage.getItem(k) || '0', 10) + 1;
    try { sessionStorage.setItem(k, String(n)); } catch (e) {}
    return n;
  }

  // 1) 页面浏览(带路径 + 来源 + 会话内顺序)
  track('page', {
    path: path, page_type: ptype,
    referrer_path: referrerPath(), nav_index: navIndex()
  });

  // 2) 滚动深度:25/50/75/100% 各发一次
  var fired = {};
  var maxScroll = 0;
  function scrollPct() {
    var h = document.documentElement;
    var denom = h.scrollHeight - h.clientHeight;
    if (denom <= 0) return 100;
    var top = h.scrollTop || window.pageYOffset || 0;
    return Math.min(100, Math.round(top / denom * 100));
  }
  function onScroll() {
    var p = scrollPct();
    if (p > maxScroll) maxScroll = p;
    [25, 50, 75, 100].forEach(function (d) {
      if (p >= d && !fired[d]) {
        fired[d] = true;
        track('scroll_depth', { path: path, page_type: ptype, depth: d });
      }
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll(); // 短页面初始即可能已 100%

  // 3) 页面退出:停留时长 + 离开时最大滚动
  var start = Date.now();
  var exited = false;
  function onExit() {
    if (exited) return;
    exited = true;
    track('page_exit', {
      path: path, page_type: ptype,
      max_scroll: maxScroll,
      dwell_seconds: Math.round((Date.now() - start) / 1000)
    });
  }
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') onExit();
  });
  window.addEventListener('pagehide', onExit);

  // 4) 博客广告点击(.plw-ad-promo 内链接)→ 广告漏斗
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.plw-ad-promo a, .plw-ad-promo [href]');
    if (!a) return;
    var slotEl = a.closest('[data-slot]');
    var href = a.getAttribute('href') || '';
    var target = href;
    try { target = new URL(href, location.origin).pathname; } catch (ignore) {}
    track('ad_click', {
      slot: (slotEl && slotEl.getAttribute('data-slot')) || '',
      target_path: target,
      from_path: path
    });
  }, true);
})();
